import '@kern-ux/native/dist/fonts/fira-sans.css'
import '@kern-ux/native/dist/kern.min.css'
import './styles.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { hideSplash } from './app/splash'
import { restoreTenant } from './app/tenant'
import { initAuth } from './auth/auth'

const root = createRoot(document.getElementById('root')!)

restoreTenant()

initAuth()
  .then(() =>
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  )
  .catch((error: unknown) => {
    console.error(error)
    hideSplash()
    root.render(
      <main className="kern-container py-48">
        <h1 className="kern-heading kern-heading-large">Anmeldung nicht möglich</h1>
        <p className="kern-body">
          Der Anmeldedienst ist nicht erreichbar. Bitte laden Sie die Seite später erneut.
        </p>
      </main>,
    )
  })
